import './html_editor_view.js.coffee'
import './plain_editor_view.js.coffee'

class ToggleableHTMLEditorView extends Backbone.View
  className: 'toggleable-html-editor'
  editorClasses:
    html: HtmlEditorView
    plain: PlainEditorView

  initialize: ({mode, textLimit, boxSize, codeEditorEnabled}) ->
    @_setMode(mode)
    @textLimit = textLimit
    @boxSize = boxSize
    @codeEditorEnabled = codeEditorEnabled || false

  render: (text) =>
    text ||= @getPlainHTML() if @mode == 'html'
    text ||= @getPlainText()
    @editorView = @editorClasses[@mode].create(
      @$el
      text: text
      textLimit: @textLimit
      boxSize: @boxSize
      codeEditorEnabled: @codeEditorEnabled
    ).render()
    @

  toggleMode: (mode) =>
    @_setMode(mode)
    @render()

  getPlainHTML: =>
    return undefined unless @editorView
    @editorView.update()
    @editorView.getPlainHTML()

  getPlainText: =>
    return undefined unless @editorView
    @editorView.update()
    @editorView.getPlainText()

  focus: =>
    @editorView.focus()

  toggleError: (showError) =>
    @$el.toggleClass('error', showError)

  insertTextAtCursor: (text) =>
    @editorView.insertTextAtCursor(text)

  _setMode: (mode) =>
    unless _.includes(@_validModes(), mode)
      throw new Error("Invalid mode: #{mode}")
    @mode = mode
    @$el.addClass(mode)
    for mode in _.without(@_validModes(), mode)
      @$el.removeClass(mode)

  _validModes: =>
    Object.keys(@editorClasses)

window.ToggleableHTMLEditorView = ToggleableHTMLEditorView
